import { Row, Col, Button, Space } from "antd";
import ContentHeaderComponent from "../../shared/components/content-header/content-header.component";
import DataTableComponent from "../../shared/components/data-table/data-table.component";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { BiFilterAlt } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../shared/types/common";
import { useEffect, useState } from "react";
import { TABLE_ROWS_COUNT } from "../../shared/constants";
import { getAccountsList } from "../../core/store/reducers/accounts.slice";
import {
  getForexList,
  requestGetByModuleCommon,
} from "../../core/store/reducers/master.slice";
import {
  accessAllowed,
  formatAmount,
  formatDate,
  formatMonthYear,
} from "../../shared/utils/utils";
import GenericFormComponent from "../../shared/components/generic-form/generic-form.component";
import { useForm } from "antd/lib/form/Form";
import CreateEditForexComponent from "./components/create-edit-forex.component";
import { allPermissions } from "../../shared/constants/constants";

const ManageForexPage: React.FC = () => {
  const dispatch = useDispatch();
  const { loadingForex, forexList, pagination } = useSelector(
    (state: RootState) => state.master
  );
  const { myPermissions } = useSelector((state: RootState) => state.auth);
  const [form] = useForm();
  const { screenType } = useSelector((state: RootState) => state.settings);
  const [createEditOpen, setCreateEditOpen] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null as any);
  const [filterVisible, setFilterVisible] = useState(false);
  const [sorter, setSorter] = useState({ sort_by: "", sort_type: "" });
  const [filters, setFilters] = useState({} as any);
  const [currencies, setCurrencies] = useState<any[]>([]);

  console.log(forexList);

  useEffect(() => {
    loadList();
  }, [filters, sorter]);

  const loadList = (page: any = null) => {
    const data = {
      page: page ? page : pagination?.page ? pagination?.page : 1,
      limit: pagination?.limit || TABLE_ROWS_COUNT,
      ...sorter,
    };
    let filter = {} as any;
    Object.keys(filters)?.map((val: any) => {
      if (filters[val]) filter[val] = filters[val];
    });
    dispatch(getForexList({ params: data, body: filter }));
  };

  const createEntityListner = () => {
    setCreateEditOpen(true);
    setSelectedEntity(null);
  };
  const editEntityListner = (entity: any) => {
    setCreateEditOpen(true);
    setSelectedEntity(entity);
  };

  const headerButtons = (
    <Space>
      { accessAllowed(myPermissions, allPermissions.CREATE_FOREX) && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={createEntityListner}
        >
          <span className="font-size-14">
            New {!screenType?.isPortrait && "Forex"}
          </span>
        </Button>
      )}
      <Button
        shape="circle"
        type="primary"
        icon={
          <span role="img" className="anticon">
            <BiFilterAlt />
          </span>
        }
        onClick={() => {
          setFilterVisible(!filterVisible);
        }}
      ></Button>
    </Space>
  );

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const fetchCurrencies = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_currency" })
      ).unwrap();
      if (response?.success) {
        const currencylist = response?.data.items;
        const filtereCurrencyList = currencylist.filter(
          (item: any) => item.name !== "INR"
        );
        setCurrencies(filtereCurrencyList);
      }
    } catch (error) {
      console.error("Failed to fetch currencies:", error);
    }
  };

  const onFilterApply = (values: any) => {
    setFilters(values);
  };

  const onValuesChange = (_value: any, _allValues: any) => {};

  const formProps = {
    form: form,
    name: "manage-project-filters",
    enableEnterSubmit: true,
    formElements: [
      {
        name: "currencyId",
        label: "",
        placeholder: "Currency",
        type: "Select",
        colSpanResponsive: { xs: 12, sm: 8, md: 6, lg: 4 },
        showSearch: true,
        allowClear: true,
        mode: "multiple",
        options: currencies?.map((Currency: any) => ({
          value: Currency?.id,
          label: Currency?.name,
        })),
      },
    ],
    initialValues: {
      name: "",
    },
    extraButtons: [
      {
        htmlType: "submit",
        colSpanResponsive: { xs: 12, sm: 8, md: 6, lg: 3 },
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpanResponsive: { xs: 12, sm: 8, md: 6, lg: 3 },
        loading: false,
        submitButtonText: "Apply",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFilterApply,
    onFinishFailed: null,
    onValuesChange: onValuesChange,
  };

  const columns = [
    {
      title: "Currency",
      dataIndex: "currencyName",
      key: "currencyName",
    },
    {
      title: "Start Month",
      dataIndex: "startDate",
      key: "startDate",
      render: (value: string) => formatMonthYear(value),
    },
    {
      title: "End Month",
      dataIndex: "endDate",
      key: "endDate",
      render: (value: string) => (value ? formatMonthYear(value) : ""),
    },
    {
      title: "INR Multiplier",
      dataIndex: "inrMultiplier",
      key: "inrMultiplier",
      render: (inrMultiplier: number) =>
        inrMultiplier ? formatAmount(inrMultiplier) : "",
    },
    ...(accessAllowed(myPermissions, allPermissions.UPDATE_FOREX)
      ? [
          {
            title: "Actions",
            key: "actions",
            fixed: "right",
            render: (_text: any, record: any) => (
              <Space>
                <Button
                  type="link"
                  onClick={() => editEntityListner(record)}
                  icon={<EditOutlined />}
                />
              </Space>
            ),
          },
        ]
      : []),
  ];
  

  const onChangeHandler = (_pagination: any, _filters: any, _sorter: any) => {
    if (_sorter.order === undefined) {
      setSorter({ sort_by: "", sort_type: "" });
    } else {
      let order = "";
      let columnKey = "";
      if (_sorter.order === "ascend") order = "asc";
      else order = "desc";

      if (_sorter.columnKey === "enabled") {
        columnKey = "status";
      } else if (_sorter.columnKey === "displayName") {
        columnKey = "name";
      } else {
        columnKey = _sorter.columnKey;
      }
      setSorter({ sort_by: columnKey, sort_type: order });
    }
  };

  const onPageChange = (pageNumber: number) => {
    loadList(pageNumber);
  };

  const createEditSubmit = () => {
    setCreateEditOpen(false);
    loadList();
  };

  return (
    <>
      <div className="mx-6 mt-2 bg-primary-white-blueish border-primary-gray-02 no-border-bottom">
        <Row>
          <Col span={24}>
            <ContentHeaderComponent
              title="Manage Forex"
              subtitle=""
              buttons={headerButtons}
            />
          </Col>
        </Row>
        {filterVisible && (
          <Row className="bg-filter">
            <Col span={24} className="py-1">
              <div className="px-3 table-filter-form">
                <GenericFormComponent {...formProps} />
              </div>
            </Col>
          </Row>
        )}
        <DataTableComponent
          rowKey="id"
          pagination={true}
          loading={loadingForex}
          dataSource={forexList} // ✅ safe fallback
          columns={columns}
          onChange={onChangeHandler}
          defaultPage={0}
          currentPage={pagination?.page || 1}
          totalRows={pagination?.total || 0}
          onPageChange={onPageChange}
        />
      </div>

      {createEditOpen && (
        <CreateEditForexComponent
          onClose={() => setCreateEditOpen(false)}
          visible={createEditOpen}
          selectedEntity={selectedEntity}
          onSubmit={createEditSubmit}
          currencies={currencies}
        />
      )}
    </>
  );
};

export default ManageForexPage;
